var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenealogyReport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 19,
    viewBox: "0 0 15 19",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.125 1H2.625C2.19402 1 1.7807 1.1712 1.47595 1.47595C1.1712 1.7807 1 2.19402 1 2.625V15.625C1 16.056 1.1712 16.4693 1.47595 16.774C1.7807 17.0788 2.19402 17.25 2.625 17.25H12.375C12.806 17.25 13.2193 17.0788 13.524 16.774C13.8288 16.4693 14 16.056 14 15.625V5.875L9.125 1Z",
    stroke: "#313645",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.125 1V5.875H14"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.125 1V5.875H14",
    stroke: "#313645",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 9.9375H4.25",
    stroke: "#313645",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 13.1875H4.25",
    stroke: "#313645",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenealogyReport);
export default __webpack_public_path__ + "static/media/GenealogyReport.c4b615ad216df39e62aba3766b0c412b.svg";
export { ForwardRef as ReactComponent };